import { makeVar } from '@apollo/client'

export const searchedBillerDetails = makeVar({})
export const selectedBillerDetails = makeVar({})
export const successMessageDetails = makeVar({})
export const getbillerCache = makeVar({})
export const userAccount = makeVar({})
export const RestAPICache = makeVar({})
export const payeeDashbord = makeVar({})
export const systemErrorCache = makeVar({})
